import { fromUnixTime } from 'date-fns/fromUnixTime'

import Avatar from '@mui/material/Avatar'
import IconButton from '@mui/material/IconButton'
import ListItem from '@mui/material/ListItem'
import ListItemAvatar from '@mui/material/ListItemAvatar'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import Stack from '@mui/material/Stack'

import { ArrowUpwardAlt } from '@mxenabled/mx-icons'

import { Text } from '@mxenabled/mxui'

import { useGlobalCopyStore } from '../../../common'
import { DATE_FORMATS_INTL, formatDate } from '../../../core/constants'
import { Goal, GoalType, TrackType } from '../../../core'

import { getGoalStatusData } from '../../../core/utils/GoalsUtil'
import { formatCurrency } from '../../../core/utils/NumberFormatting'
import { buildDynamicCopy } from '../../../core/utils/Localization'

interface OngoingListItemProps {
  goal: Goal
  index: number
  onUpClick?: (goal: Goal) => void
}

export const OngoingListItem = ({ goal, index, onUpClick }: OngoingListItemProps) => {
  const { goals: copy } = useGlobalCopyStore()
  const { percentage } = getGoalStatusData(copy, goal)
  const completionMessage: string =
    goal.goal_type === GoalType.KEEP_BALANCE_BELOW || goal.has_been_spent
      ? copy.goal_completed
      : (buildDynamicCopy(copy.goal_percentage_reached, `${percentage * 100}`) as string)
  return (
    <ListItem>
      <ListItemButton
        disableRipple={true}
        sx={{ ':hover': { backgroundColor: 'unset' }, cursor: 'default' }}
      >
        {goal.track_type !== TrackType.RETIREMENT_TRACK && (
          <ListItemAvatar
            sx={{
              alignItems: 'center',
              display: 'flex',
              justifyContent: 'center',
              '.MuiAvatar-root': { height: '16px', width: '16px' },
            }}
          >
            {goal.track_type === TrackType.SAVINGS_TRACK ? (
              <IconButton onClick={() => onUpClick?.(goal)}>
                <ArrowUpwardAlt color="primary" size={24} />
              </IconButton>
            ) : (
              <Avatar sx={{ bgcolor: 'text.primary', height: '16px', width: '16px' }}>
                <Text bold={true} variant="caption">
                  {index + 1}
                </Text>
              </Avatar>
            )}
          </ListItemAvatar>
        )}
        <ListItemText slotProps={{ primary: { variant: 'body1' } }}>
          <Stack alignItems="center" direction="row" justifyContent="space-between">
            <Stack sx={{ maxWidth: '70%' }}>
              <Text bold={true} variant="body1">
                {goal.name}
              </Text>
              <Text variant="caption">
                {goal.is_complete
                  ? completionMessage
                  : (buildDynamicCopy(
                      copy.goal_projection,
                      formatDate(
                        fromUnixTime(goal.projected_to_complete_at || 0),
                        DATE_FORMATS_INTL.MONTH_SHORT_YEAR,
                      ),
                    ) as string)}
              </Text>
            </Stack>
            <Text bold={true} variant="body1">
              {formatCurrency(goal.amount, '0,0.00')}
            </Text>
          </Stack>
        </ListItemText>
      </ListItemButton>
    </ListItem>
  )
}
